require("slick-carousel");
require('../app/news.coffee')
require('../app/priority_icons.coffee')
require('../app/image_resizer.coffee')

window.homePageInitFlag = false
window.hiddenNews = ''

pageInit = ->
  new window.News()
  new window.ImageResizer()
  mainBackground = $('.home-main__video-wrapper video')
  window.hiddenNews = document.querySelector(".js-repeated-hidden-news");

  $('.home__banners-slider').slick({
    prevArrow: $('.home-banners-slider__arrow-left')
    nextArrow: $('.home-banners-slider__arrow-right')
    dots: true
    autoplay: true
    autoplaySpeed: 4000
  })

  cardToggleSetHeight()
  toggleSideNews()

  $(window).resize ->
    cardToggleSetHeight()
    toggleSideNews()

  $(window).scroll ->
    shift = $(window).scrollTop()
    mainBackground.css('top', (-100 + (shift*.15))+'px')

cardToggleSetHeight =->
  $('.card-toggle').each ->
    $(this).find('.card-toggle__description').css('height', 'auto')
    descriptionHeight = $(this).find('.card-toggle__description').css('height')
    $(this).find('.card-toggle__description').css('height', descriptionHeight)

# Удаляем скрытую новость в начале основного списка новостей на широкоформатном экране (ее наличие ломает верстку в IE)
toggleSideNews =->
  if ($(window).outerWidth() >= '1088')
    if $('.js-repeated-hidden-news').length > 0
      $('.js-repeated-hidden-news').remove();
  else
    if $('.js-repeated-hidden-news').length == 0
      $('.js-loaded-items-container').prepend(window.hiddenNews)



$(document).ready ->
  if window.homePageInitFlag != true
    pageInit()
  window.homePageInitFlag = true



// WEBPACK FOOTER //
// ./assets/javascripts/pages/home.coffee